import { useContext } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import {
  OverlayContextProvider,
  OverlayContextProps,
  OverlayContext,
  overlayContextDefaults,
} from '@wix/da-react-context/pkg/OverlayContext';
import { DeviationTypes } from '../../types/deviation';
import { getDeviationType } from '../_helpers';
import { useDeviationAttributes } from './useDeviationAttributes';

/** almost same as useContext(OverlayContext), but with correct defaults */
export function useOverlayContext(deviation: PapiDeviation) {
  const { isFavouritable, isCommentable } = useDeviationAttributes(deviation, false);

  const deviationType = getDeviationType(deviation);

  const canShowTitle = ![
    DeviationTypes.JOURNAL,
    DeviationTypes.LITERATURE,
    DeviationTypes.POLL,
    DeviationTypes.STATUS,
    DeviationTypes.TIER,
  ].includes(deviationType);

  const rawContext = useContext(OverlayContext);
  const contextOverrides =
    deviationType === DeviationTypes.TIER
      ? {
          showTitle: false,
          showAuthor: false,
          showFaveControl: false,
          showCommentControl: false,
          showBoosted: false,
        }
      : {};

  const {
    showTitle,
    showFaveControl,
    showCommentControl,
    showFaveEngagementIcon,
    showCommentEngagementIcon,
    ...restContext
  } = {
    ...overlayContextDefaults,
    ...rawContext,
    ...contextOverrides,
  };

  return {
    showTitle: canShowTitle && showTitle,
    showFaveControl: isFavouritable && showFaveControl,
    showCommentControl: isCommentable && showCommentControl,
    showFaveEngagementIcon: isFavouritable && showFaveControl && showFaveEngagementIcon,
    showCommentEngagementIcon: isCommentable && showCommentControl && showCommentEngagementIcon,
    ...restContext,
  };
}

export { OverlayContextProvider, type OverlayContextProps };
